/**
 *
 */
export default function stripDarkFromRoute(route) {
  return route.replace('-dark', '');
}